
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  const hoverClasses = hover ? 'hover:shadow-xl hover:-translate-y-1 cursor-pointer' : '';
  
  return (
    <div className={`bg-white rounded-xl shadow-lg transition-all duration-300 ${hoverClasses} ${className}`}>
      {children}
    </div>
  );
}
